//export const apiurl="http://localhost/holisticstraining/public/";
export const apiurl="https://trainingadmin.holisticslab.my/";